import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'MainPage',
    // route level code-splitting
    // this generates a separate chunk (MainPage.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/main/Main')
  },
  {
    path: '/guessNo',
    name: 'GuessNo',
    component: () => import('../views/pages/GuessNo/GuessNo')
  },
  {
    path: '/answers',
    name: 'Answers',
    component: () => import('../views/pages/bookOfAnswers/BOA')
  },
  {
    path: '/iLoveU',
    name: 'ILoveU',
    component: () => import('../views/three/pages/iLoveU/ILoveU')
  },
  {
    path: '/stack',
    name: 'Stack',
    component: () => import('../views/three/pages/pileGame/Stack')
  },
  {
    path: '/sorry',
    name: 'Sorry',
    component: () => import('../views/pages/HeartParticles/HeartParticles')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
